export default __webpack_public_path__ + "static/media/majaliwa.bfe451be.jpg";